import styled from '@emotion/styled'
import { faHandshake, faNewspaper, faShoppingBag, faUserPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import { useLangSelected } from '../../../../hooks/useLangSelected'
import DashboardCard from '../components/DashboardCard'

const ActionButton = styled.button`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 1.4rem;
    font-weight: 500;
    color: #374151;

    &:hover {
        background: #f3f4f6;
        border-color: #d1d5db;
        transform: translateY(-2px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    &:active {
        transform: translateY(0);
    }

    &:focus {
        outline: 2px solid #b40000;
        outline-offset: 2px;
    }
`

const ActionIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #fee2e2;
    border-radius: 8px;
    color: #b40000;
    font-size: 1.8rem;
`

const ActionsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
`

const QuickActionsWidget = () => {
    const { t } = useTranslation()
    const lng = useLangSelected()

    // Quick actions are static, no loading state needed
    const actions = [
        {
            label: t('adminDashboard.widgets.quickActions.addUser'),
            icon: <FontAwesomeIcon icon={faUserPlus} />,
            path: `/${lng}/bva-admin/utilisateurs`,
        },
        {
            label: t('adminDashboard.widgets.quickActions.addArticle'),
            icon: <FontAwesomeIcon icon={faNewspaper} />,
            path: `/${lng}/bva-admin/articles`,
        },
        {
            label: t('adminDashboard.widgets.quickActions.addProduct'),
            icon: <FontAwesomeIcon icon={faShoppingBag} />,
            path: `/${lng}/bva-admin/shop/produits`,
        },
        {
            label: t('adminDashboard.widgets.quickActions.addPartner'),
            icon: <FontAwesomeIcon icon={faHandshake} />,
            path: `/${lng}/bva-admin/partenaires`,
        },
    ]

    return (
        <DashboardCard
            title={t('adminDashboard.widgets.quickActions.title')}
            icon={<FontAwesomeIcon icon={faHandshake} />}
        >
            <ActionsGrid>
                {actions.map((action) => (
                    <ActionButton
                        key={action.path}
                        onClick={() => (window.location.href = action.path)}
                        aria-label={action.label}
                    >
                        <ActionIcon>{action.icon}</ActionIcon>
                        <span>{action.label}</span>
                    </ActionButton>
                ))}
            </ActionsGrid>
        </DashboardCard>
    )
}

export default QuickActionsWidget
